import black from '../images/whiteboards/black.png';
import blue from '../images/whiteboards/blue.png';
import cyan from '../images/whiteboards/cyan.png';
import orange from '../images/whiteboards/orange.png';
import red from '../images/whiteboards/red.png';
import gray from '../images/whiteboards/gray.png';
import green from '../images/whiteboards/green.png';

const whiteboards = {
  'whiteboardBlack': {
    id: 'whiteboardBlack',
    title: 'Black',
    subtitle: 'Basic',
    type: 'BANNER',
    color: 'BLACK',
    height: 12, // 20yd = 720in
    width: 32, // 53.33yd = 1920in | 32/(1920/720) = 12
    pixelWidth: 1107,
    pixelHeight: 640,
    imageSrc: black,
    thumbImageSrc: black,
  },
  'whiteboardBlue': {
    id: 'whiteboardBlue',
    title: 'UF Blue',
    subtitle: 'Basic',
    type: 'BANNER',
    color: 'BLUE',
    height: 12, // 20yd = 720in
    width: 32, // 53.33yd = 1920in | 32/(1920/720) = 12
    pixelWidth: 1107,
    pixelHeight: 640,
    imageSrc: blue,
    thumbImageSrc: blue,
  },
  'whiteboardCyan': {
    id: 'whiteboardCyan',
    title: 'UF Cyan',
    subtitle: 'Basic',
    type: 'BANNER',
    color: 'CYAN',
    height: 12, // 20yd = 720in
    width: 32, // 53.33yd = 1920in | 32/(1920/720) = 12
    pixelWidth: 1107,
    pixelHeight: 640,
    imageSrc: cyan,
    thumbImageSrc: cyan,
  },
  'whiteboardOrange': {
    id: 'whiteboardOrange',
    title: 'UF Orange',
    subtitle: 'Basic',
    type: 'BANNER',
    color: 'ORANGE',
    height: 12, // 20yd = 720in
    width: 32, // 53.33yd = 1920in | 32/(1920/720) = 12
    pixelWidth: 1107,
    pixelHeight: 640,
    imageSrc: orange,
    thumbImageSrc: orange,
  },
  'whiteboardRed': {
    id: 'whiteboardRed',
    title: 'Red',
    subtitle: 'Basic',
    type: 'BANNER',
    color: 'RED',
    height: 12, // 20yd = 720in
    width: 32, // 53.33yd = 1920in | 32/(1920/720) = 12
    pixelWidth: 1107,
    pixelHeight: 640,
    imageSrc: red,
    thumbImageSrc: red,
  },
  'whiteboardGray': {
    id: 'whiteboardGray',
    title: 'Gray',
    subtitle: 'Basic',
    type: 'BANNER',
    color: 'GRAY',
    height: 12, // 20yd = 720in
    width: 32, // 53.33yd = 1920in | 32/(1920/720) = 12
    pixelWidth: 1107,
    pixelHeight: 640,
    imageSrc: gray,
    thumbImageSrc: gray,
  },
  'whiteboardGreen': {
    id: 'whiteboardGreen',
    title: 'Green',
    subtitle: 'Basic',
    type: 'BANNER',
    color: 'GREEN',
    height: 12, // 20yd = 720in
    width: 32, // 53.33yd = 1920in | 32/(1920/720) = 12
    pixelWidth: 1107,
    pixelHeight: 640,
    imageSrc: green,
    thumbImageSrc: green,
  }
};

export default whiteboards;
